import React from 'react';
import moment from 'moment';

const ListOfMinistryColumns = ({
  pageNo = 0,
  size = 10,
  onSortChange = () => {},
  sortColumn = '',
  sortOrder = ''
}) => {
  const getSortIndicator = (field) => {
    if (sortColumn !== field) return null;
    return sortOrder === 'asc' ? ' 🔼' : ' 🔽';
  };

  const handleHeaderClick = (field) => () => {
    onSortChange({ dataField: field });
  };

  return [
    {
      dataField: '',
      text: 'S.No',
      formatter: (cell, row, rowIndex) => {
        return (pageNo * size) + (rowIndex + 1);
      }
    },
    {
      dataField: 'eventId',
      text: `Event ID`,
      headerEvents: { onClick: handleHeaderClick('eventId') }
    },
    {
      dataField: 'ministryName',
      text: `Ministry Name`,
      headerEvents: { onClick: handleHeaderClick('eventName') },
      formatter: (cell) => (
        <span title={cell}>{cell}</span>
      )
    },
    
    {
      dataField: 'eventName',
      text: `Event Name`,
      headerEvents: { onClick: handleHeaderClick('eventName') },
      formatter: (cell) => (
        <span title={cell}>{cell}</span>
      )
    },
    
    {
      dataField: 'yearOfEngagement',
      text: `Year of Engagement`,
      sort : true,
      headerEvents: { onClick: handleHeaderClick('yearOfEngagement') },
    },
  ];
};

export default ListOfMinistryColumns;
